import { Options } from '@mui/material'
import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedResponse, PaginatedParams } from 'services/api/types'

const fetcher = (params: PaginatedParams): PaginatedResponse<Options> => {
  const { page = 1, limit = 100 } = params
  return axios.get(`orders/cancel-motives`, {
    params: { ...params, page, limit }
  })
}

export function useLoadConcepts(params: PaginatedParams) {
  return useQuery(['ordersCancelMotives', params], () => fetcher(params), {
    onError: () =>
      toast.error('Não foi possível carregar os motivos de cancelamento!', {
        toastId: 'ordersCancelMotives'
      })
  })
}
